import * as React from 'react';
import {useExpertises} from "../../hooks/useExpertises";
import {useInView} from "react-intersection-observer";
 

export const ExpertisesList = ({currentExp , lang}) => {
  const data =useExpertises();

  const expertisesTranslate ={}
  const subExpTranslate= {}
  data.forEach((d)=>{
    expertisesTranslate[d.id]=d.display_name[lang];
    d.subitems.forEach((sub)=>{
      subExpTranslate[sub.id] =sub.display_name[lang]
    })
  })
const result = []
  currentExp.forEach((item)=>{
    const {id , subitems} = item;
    if(id){
      const subItemsProject = []
      if(subitems.length ){
        subitems.forEach((sub)=>{
          subItemsProject.push(subExpTranslate[sub])
        })
      }
      result.push({
        title:expertisesTranslate[id],
        subItems: subItemsProject
      })
    }
  })


  return (

    <div   className="project-description__list ">
      {
        result.map(( res , i )=>{
              return   <Exp key ={i} title={res.title} subItems={res.subItems}/>
        })
      }

    </div>
  );
};


const Exp = ({title, subItems})=>{
  const [ref, inView  ] = useInView({triggerOnce:true} );

  return    <ul className={inView? "animate__animated animate__backInRight" : " hide"}  ref={ref} style={{marginBottom:20}}>
    <li>{title}</li>
    {  subItems.map(( text , i )=>{
      return   <li key ={i} > {text}   </li>
    })}
  </ul>
}